import { SsoIntegrationProviderPresetEnum } from '@lib/graphql-common';

const PROVIDER_DISPLAY_NAME_MAP: Record<
  SsoIntegrationProviderPresetEnum,
  string
> = {
  [SsoIntegrationProviderPresetEnum.Google]: 'Google',
  [SsoIntegrationProviderPresetEnum.Microsoft]: 'Microsoft',
  [SsoIntegrationProviderPresetEnum.Okta]: 'Okta',
  [SsoIntegrationProviderPresetEnum.Auth0]: 'Auth0',
  [SsoIntegrationProviderPresetEnum.Onelogin]: 'OneLogin',
  [SsoIntegrationProviderPresetEnum.Custom]: 'SSO',
};

export default function getSsoProviderDisplayName(
  preset: SsoIntegrationProviderPresetEnum,
): string {
  return PROVIDER_DISPLAY_NAME_MAP[preset] || preset;
}
